import { useMutation, useQueryClient } from '@tanstack/react-query';
import { promotionsService } from '../services/promotions.service';

export function useDeletePromotion() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (refId: string) => promotionsService.deletePromotion(refId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['promotions'] });
    },
  });
}

export function useDeletePromotionCode() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (codeRefId: string) => promotionsService.deletePromotionCode(codeRefId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['promotion-codes'] });
      queryClient.invalidateQueries({ queryKey: ['promotions'] });
    },
  });
}
